import { NavLink } from "react-router-dom";
import { showToast } from "../../../utils/notification";

export const InsureframeModals = ({ modal }) => {
  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="fixed left-0 right-0 top-0 z-50 z-[500] flex h-screen max-h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-dark-100/[.9] md:inset-0"
      >
        <div className="relative max-h-full w-full max-w-2xl p-4">
          <div className="relative rounded-lg bg-white shadow dark:bg-gray-700">
            <div className="flex items-center justify-between rounded-t border-b p-4 dark:border-gray-600 md:p-5">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                {modal.title}
              </h3>
              <button
                type="button"
                onClick={modal.onClose}
                className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                <svg
                  className="h-3 w-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">{modal.cancelLabel}</span>
              </button>
            </div>
            {modal.modalId === "terms-and-condition" && (
              <div className="space-y-4 p-4 md:p-5">
                <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                  Pentru a continua cu selecția ofertei de asigurare, vă rugăm
                  să citiți și să acceptați{" "}
                  <NavLink
                    to="/terms"
                    class="text-blue-600 hover:underline dark:text-blue-500"
                    target="_blank"
                  >
                    Termenii și Condițiile
                  </NavLink>
                  . Acceptarea acestora este necesară pentru a finaliza procesul
                  de asigurare.
                </p>
              </div>
            )}
            {modal.modalId === "payment-redirection" && (
              <div className="space-y-4 p-4 md:p-5">
                <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                  După apăsarea butonului de continuare veți fi redirecționat
                  către pagina de plată. După finalizarea procesului de plată vă
                  puteți întoarce pe această pagină pentru a putea finaliza
                  procesul de emitere. Pentru a trimite link-ul către altcineva,
                  puteți{" "}
                  <a
                    onClick={() => {
                      navigator.clipboard.writeText(modal.paymentLink);
                      showToast({
                        type: "success",
                        toastId: "copy-link",
                        content: "Link-ul a fost copiat!",
                      });
                    }}
                    className="cursor-pointer text-blue-600 hover:underline dark:text-blue-500"
                  >
                    copia link-ul de plată
                  </a>
                  .
                </p>
              </div>
            )}
            {modal.modalId === "prepare-download" && (
              <div className="space-y-4 p-4 md:p-5">
                <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                  Documentul a fost generat și este gata de descărcare.
                </p>
              </div>
            )}

            <div className="flex items-center rounded-b border-t border-gray-200 p-4 dark:border-gray-600 md:p-5">
              <button
                onClick={modal.onConfirm}
                type="button"
                className="rounded-lg bg-primary-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                {modal.confirmLabel}
              </button>
              <button
                onClick={modal.onClose}
                type="button"
                className="ms-3 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-700"
              >
                {modal.cancelLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
